import { useEffect, useState } from 'react'

/**
 * Есть ли у устройства камера: на ПК и планшете без неё кнопка «Сканер» не нужна, остаётся «Выбрать фото».
 * Пока ответа нет, а также когда браузер не умеет перечислять устройства, считаем, что камера может быть:
 * само окно сканера объяснит, если потока нет.
 */
export function useHasCamera(): boolean {
  const [has, setHas] = useState(true)
  useEffect(() => {
    const media = typeof navigator === 'undefined' ? undefined : navigator.mediaDevices
    if (typeof media?.enumerateDevices !== 'function') return undefined
    let cancelled = false
    media
      .enumerateDevices()
      .then((devices) => {
        if (!cancelled) setHas(devices.some((device) => device.kind === 'videoinput'))
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [])
  return has
}
